import { Injectable  } from '@angular/core';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/* Ambiente */

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private manager: UserManager = new UserManager(getClientSettings());
  public user !: User;

  public authotizationStarted = false;

  constructor(private router: Router) {
    this.manager.getUser().then((user: any) => {
      this.user = user!;
    });
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    localStorage.clear();
    this.authotizationStarted = true;
    localStorage.setItem('authotizationStarted','true');
    localStorage.setItem('token_one', 'token_app');
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
    });
  }

  logoutUser(){
    let token = localStorage.getItem('token_one')!;
    if(token != 'token_app'){
      this.isLogoutUser().then(() => {
        this.removeUser();
        localStorage.clear();
      });
    } else {
      localStorage.clear();
      this.router.navigate(['/sign-in']);
    }
  }

  isLogoutUser(): Promise<void> {
    return this.manager.signoutRedirect({ id_token_hint: localStorage.getItem('token_one') });
  }

  clearState() {
    this.manager.clearStaleState();
  }

  removeUser() {
    this.manager.removeUser();
  }

}

export function getClientSettings(): UserManagerSettings {
  return {
    authority: environment.authority,
    client_id: environment.client_id_one,
    redirect_uri: environment.redirec_url,
    post_logout_redirect_uri: environment.url_app_login,
    response_type: "id_token token",
    scope:"openid profile",
    filterProtocolClaims: true,
    loadUserInfo: true,
    includeIdTokenInSilentRenew: true,
    automaticSilentRenew: true,
    silent_redirect_uri: environment.silent_url_login
  };
}
